import React from 'react';
import { connect } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import UserListSearch from '../../components/Search/UserListSearch';
import client from '../../lib/apolloClient';

const UserListSearchContainer = props => (
  <ApolloProvider client={client}>
    <UserListSearch {...props} />
  </ApolloProvider>
);

export default connect()(UserListSearchContainer);